<template>
  <div class="button" @mousedown="down" @touchstart.prevent="down" @mouseup="up" @mouseleave="up" @touchend="up">
    <slot />
    <transition name="wave">
    <div v-if="active" class="wave" :style="waveStyle" />
    </transition>
  </div>
</template>

<script>

/**
 * @param {Number} x
 * @param {Number} y
 * @param {DOMRect} rect
 * @returns {number}
 */
function distanceToFurthestCorner(x, y, rect) {
  /*
  1) find the largest rect
    +-----*----+
    |     *    |
    ******x    |
    |__________+
  2) calculate diagonal of the largest rect
  */
  const dX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right))
  const dY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom))
  return Math.sqrt(dX * dX + dY * dY)
}

export default {
  name: 'UiButton.vue',
  data: () => ({
    active: 0,
    waveStyle: {},
  }),
  methods: {
    /** @param {MouseEvent} e */
    down(e) {
      if (this.active) return
      this.active = Date.now()
      console.log('mouse down')
      const rect = this.$el.getBoundingClientRect()
      const x = e.clientX || e.touches[0].clientX
      const y = e.clientY || e.touches[0].clientY
      const radius = distanceToFurthestCorner(x, y, rect);

      const offsetLeft = x - rect.left - radius
      const offsetTop = y - rect.top - radius
      this.waveStyle = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        width: `${radius * 2}px`,
        height: `${radius * 2}px`,
      }
    },
    up() {
      if (!this.active) return
      if (this.active + 400 > Date.now()) setTimeout(() => {
        this.active = 0
      }, this.active + 400 - Date.now());
      else {
        this.active = 0
      }
      console.log('mouse up')
    }
  }
}
</script>

<style scoped>
.button {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  border: 1px solid black;
  border-radius: 0.25rem;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  user-select: none;
}
.wave {
  position: absolute;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, .2);

}
.wave-enter-active {
  transition: transform 450ms ease-out;
}
.wave-enter-from {
  transform: scale(0) translateZ(0);
}
.wave-leave-active {
  opacity: 0;
  transition: opacity 400ms ease-out;
}
</style>
